/** True when GW dev runs behind casino-next `/game-window-play` (VITE_LOBBY_SAME_ORIGIN_DEV=1). */
export const isLobbySameOriginDev = (): boolean =>
  process.env.VITE_LOBBY_SAME_ORIGIN_DEV === '1';
